import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ActionTypes } from '../actions/actions-avc-credit-line';
import * as AvcCreditLineActions from '../actions/actions-avc-credit-line';
import { BackendAvcCreditLineService } from '../services/backend-avc-credit-line.service';
import { ReadCreditLineStatusResponse } from '../services/avc-credit-line-status.model';

@Injectable()
export class EffectsAvcCreditLine {

  setCreditLineStatus$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ActionTypes.RequestCreditLineStatus),
      switchMap(() =>
        this.backendAvcCreditLineService.getAvcCreditLineStatus().pipe(
          map(
            (response: ReadCreditLineStatusResponse) =>
              new AvcCreditLineActions.RequestCreditLineStatusSuccess(response)
          ),
          catchError(error => of(new AvcCreditLineActions.RequestCreditLineStatusError(error)))
        )
      )
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly backendAvcCreditLineService: BackendAvcCreditLineService
  ) {}
}
